import type { OpsLogisticDefinition } from '../types';
import { OPS_LOGISTICS_CATALOG as LEGACY_LOGISTICS_CATALOG } from './logisticsCatalog';
import { PARTNER_LOGISTICS_CATALOG } from './partnerLogisticsCatalog';

/**
 * Active Ops catalog. Historical `school.*` definitions remain available only
 * from logisticsCatalog.ts for rendering immutable legacy snapshots.
 */
const canonicalSquadAndDerived = LEGACY_LOGISTICS_CATALOG.filter((definition) =>
  definition.storage.kind === 'squads' || definition.storage.kind === 'derived'
);

export const ACTIVE_OPS_LOGISTICS_CATALOG: ReadonlyArray<OpsLogisticDefinition> =
  Object.freeze([...PARTNER_LOGISTICS_CATALOG, ...canonicalSquadAndDerived]);

export const ACTIVE_OPS_LOGISTICS_BY_ID: Readonly<Record<string, OpsLogisticDefinition>> =
  Object.freeze(ACTIVE_OPS_LOGISTICS_CATALOG.reduce<Record<string, OpsLogisticDefinition>>((result, definition) => {
    if (result[definition.id]) throw new Error(`Duplicate active Ops logistic id: ${definition.id}`);
    result[definition.id] = definition;
    return result;
  }, {}));

export function logisticDefinitionForSnapshot(
  logisticId: string,
  historical: boolean,
): OpsLogisticDefinition | null {
  const active = ACTIVE_OPS_LOGISTICS_BY_ID[logisticId];
  if (active) return active;
  if (!historical) return null;
  return LEGACY_LOGISTICS_CATALOG.find((definition) => definition.id === logisticId) || null;
}
